import $ from 'jquery';
import {
  CHANGE_TEAM_SEASON,
  CHANGE_TEAM_SORT,
  REQUEST_TEAM_ATHLETES,
  RECEIVE_TEAM_ATHLETES,
  FAIL_TEAM_ATHLETES_REQUEST,
  REQUEST_FOLLOW_FEED_USER,
  RECEIVE_FEED_USER_FOLLOWED,
  FAIL_FEED_USER_FOLLOW_REQUEST,
  REQUEST_UNFOLLOW_FEED_USER,
  RECEIVE_FEED_USER_UNFOLLOWED,
  FAIL_FEED_USER_UNFOLLOW_REQUEST,
} from 'common/actions';
import * as TeamSortTypes from 'common/team-sort-types';

const defaultState = {
  seasons: [],
  teamSortType: TeamSortTypes.MOST_VIEWS,
};

function roster(state = {}, action) {
  const newState = $.extend(true, {}, defaultState, state);
  let season;

  switch (action.type) {
  // Actions around following the team
  case CHANGE_TEAM_SEASON:
    newState.seasons.forEach((s) => {
      s.isSelected = s.seasonId === action.payload.season;
    });
    break;
  case CHANGE_TEAM_SORT:
    newState.teamSortType = action.payload.sort;
    break;
  case REQUEST_TEAM_ATHLETES:
    season = newState.seasons.find((s) => s.seasonId === action.payload.seasonId);
    if (season) {
      season.athleteRequestComplete = false;
      season.athleteLoadError = null;
    }
    break;
  case RECEIVE_TEAM_ATHLETES:
    season = newState.seasons.find((s) => s.seasonId === action.payload.seasonId);
    if (season) {
      if (Array.isArray(action.payload.json)) {
        season.athleteRequestComplete = true;
        season.athleteLoadError = null;
        season.athletes = action.payload.json || [];
      } else {
        season.athleteRequestComplete = false;
        season.athleteLoadError = null;
        season.athletes = [];
      }
    }
    break;
  case FAIL_TEAM_ATHLETES_REQUEST:
    season = newState.seasons.find((s) => s.seasonId === action.payload.seasonId);
    season.athleteRequestComplete = true;
    season.athleteLoadError = action.payload;
    season.athletes = [];
    break;
  case REQUEST_FOLLOW_FEED_USER:
  case REQUEST_UNFOLLOW_FEED_USER:
    if (!action.payload.isCurrentProfile) {
      newState.seasons.forEach((s) => {
        if (s.athletes  && s.athletes.length) {
          const affectedAthlete = s.athletes.find(athlete => athlete.userId === action.payload.feedUserRelatedId);
          if (affectedAthlete) {
            affectedAthlete.followRequestPending = true;
          }
        }
      });
    }
    break;
  case RECEIVE_FEED_USER_FOLLOWED:
    if (!action.payload.isCurrentProfile) {
      newState.seasons.forEach((s) => {
        if (s.athletes  && s.athletes.length) {
          const affectedAthlete = s.athletes.find(athlete => athlete.userId === action.payload.feedUserRelatedId);
          if (affectedAthlete) {
            affectedAthlete.followRequestPending = false;
            affectedAthlete.currentUserIsFollowing = true;
            affectedAthlete.followerCount += 1;
          }
        }
      });
    }
    break;
  case RECEIVE_FEED_USER_UNFOLLOWED:
    if (!action.payload.isCurrentProfile) {
      newState.seasons.forEach((s) => {
        if (s.athletes  && s.athletes.length) {
          const affectedAthlete = s.athletes.find(athlete => athlete.userId === action.payload.feedUserRelatedId);
          if (affectedAthlete) {
            affectedAthlete.followRequestPending = false;
            affectedAthlete.currentUserIsFollowing = false;
            affectedAthlete.followerCount -= 1;
          }
        }
      });
    }
    break;
  case FAIL_FEED_USER_FOLLOW_REQUEST:
  case FAIL_FEED_USER_UNFOLLOW_REQUEST:
    if (!action.payload.isCurrentProfile) {
      newState.seasons.forEach((s) => {
        if (s.athletes  && s.athletes.length) {
          const affectedAthlete = s.athletes.find(athlete => athlete.userId === action.payload.feedUserRelatedId);
          if (affectedAthlete) {
            affectedAthlete.followRequestPending = false;
            affectedAthlete.followRequestError = action.payload;
          }
        }
      });
    }
    break;
  default:
    return state;
  }
  return newState;
}

export default roster;
